import React from 'react';

function CalanderHeader({ locList, handleLocation, selectedVal }) {
  return (
    <div>
      <span className="appt-loc-val">
        <select
          className="appt-col-slct"
          style={{ width: '150px' }}
          value={selectedVal}
          onChange={(e) => handleLocation(e)}
        >
          <option value="">All Locations</option>
          {locList &&
            locList.map((data) => {
              return (
                <option key={data.id} value={data.id}>
                  {data.location_code}
                </option>
              );
            })}
        </select>
      </span>
    </div>
  );
}

export default CalanderHeader;
